import { render, staticRenderFns } from "./couponEdit.vue?vue&type=template&id=f06367dc&scoped=true&"
import script from "./couponEdit.vue?vue&type=script&lang=js&"
export * from "./couponEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06367dc",
  null
  
)

export default component.exports